require('./lbTooltip.scss');

const $inject = ['$sanitize'];

const lbTooltip = function ($sanitize) {
  return {
    controller: 'lbTooltipController',
    controllerAs: 'vm',
    bindToController: true,
    transclude: {
      tooltipContent: '?tooltipContent',
    },
    scope: {
      tooltipContent: '=',
      tooltipContentFunc: '=',
      tooltipLoadingText: '=',
      tooltipDisplay: '<',
      tooltipClass: '@',
      tooltipWidth: '@?',
      tooltipMargin: '@?',
      tooltipPadding: '@?',
      tooltipInline: '=?',
      tooltipHeader: '=',
      tooltipDirection: '@?',
      tooltipArrowPosition: '@?',
    },
    link: function (scope, element, attributes, controller, transclude) {
      if (scope.vm.tooltipDisplay === undefined) scope.vm.tooltipDisplay = true;
      scope.el = element[0];
      scope.vm.tooltipDirection = scope.vm.tooltipDirection || 'top';
      scope.vm.tooltipArrowPosition = scope.vm.tooltipArrowPosition || 'center';
      scope.tooltip = document.createElement('div');
      scope.$tooltip = angular.element(scope.tooltip);
      scope.$tooltip.addClass(scope.vm.tooltipClass || 'tooltip');
      scope.$tooltip.addClass(`tooltip--${scope.vm.tooltipDirection}`);
      scope.$tooltip.addClass(`tooltip--${scope.vm.tooltipArrowPosition}`);
      scope.isAsync = !!scope.vm.tooltipContentFunc;
      scope.isInline = !!scope.vm.tooltipInline;
      scope.tooltipWidth = scope.vm.tooltipWidth + 'px' || 'fit-content';
      scope.tooltipMargin = scope.vm.tooltipMargin + 'px' || 'fit-content';
      scope.tooltipPadding = scope.vm.tooltipPadding + 'px' || 'fit-content';

      let transcludedContent;
      let transclusionScope;

      if (scope.isInline) {
        element.wrap('<div class="tooltipWrap"></div>');
        scope.wrap = element.parent();
      }

      if (scope.tooltipClass) {
        scope.$tooltip.addClass(scope.tooltipClass);
      }

      transclude((clone) => element.append(clone));

      scope.$on('$destroy', function handleDestroyEvent() {
        scope.el.removeEventListener('mouseenter', handleMouseEnter);
        scope.el.removeEventListener('mouseleave', handleMouseLeave);
        scope.$tooltip.remove();
      });

      if (scope.vm.tooltipDisplay) {
        scope.el.addEventListener('mouseenter', handleMouseEnter);
        scope.el.addEventListener('mouseleave', handleMouseLeave);
      }

      function buildTooltip() {
        let elDimensions = scope.el.getBoundingClientRect();
        let elPos = getPosition(scope.el);
        let leftOffset = elDimensions.width / 2;
        switch (scope.vm.tooltipArrowPosition) {
          case 'left':
            leftOffset = -25;
            break;
        }
        let render = false;

        if (scope.isInline) {
          scope.docfrag = document.createDocumentFragment();
          scope.docfrag.appendChild(scope.tooltip);
          switch (scope.vm.tooltipDirection) {
            case 'top':
              scope.$tooltip.css({
                bottom: elDimensions.height + 'px',
                left: elDimensions.width / 2 + 'px',
              });
              break;
            case 'bottom':
              scope.$tooltip.css({
                top: elDimensions.height + 5 + 'px',
                left: elDimensions.width / 2 + 'px',
              });
              break;
            case 'left':
              break;
          }
        } else {
          switch (scope.vm.tooltipDirection) {
            case 'left':
              const xPos = elDimensions.right + window.scrollX;
              const yPos = elDimensions.top + window.scrollY;
              scope.$tooltip.css({
                top: yPos - 25 + 'px',
                left: xPos + 15 + 'px',
                width: 'fit-content',
              });
              break;
            default:
              scope.$tooltip.css({
                bottom: elPos.bottom + 'px',
                left: elPos.left + leftOffset + 'px',
                width: scope.tooltipWidth,
                margin: scope.tooltipMargin,
                padding: scope.tooltipPadding,
              });
          }
        }

        if (!scope.isAsync) {
          if (scope.vm.tooltipContent) {
            scope.tooltip.innerHTML = $sanitize(scope.vm.tooltipContent);
            render = true;
          } else {
            transclude(
              (clone, tScope) => {
                scope.$tooltip.append(clone);
                transcludedContent = clone;
                transclusionScope = tScope;
              },
              scope.$tooltip,
              'tooltipContent'
            );
            if (transclusionScope) {
              transclusionScope.$apply();
              render = true;
            }
          }

          if (scope.vm.tooltipHeader) {
            scope.tooltip.innerHTML = "<div class='tooltip-header'>" + scope.vm.tooltipHeader + '</div>' + scope.tooltip.innerHTML;
          }
        } else {
          scope.tooltip.innerHTML = '<span class="tooltip-loading">' + (scope.vm.tooltipLoadingText || 'Loading...') + '</span>';
          render = true;
        }

        if (!scope.tooltipCached && scope.isAsync) {
          scope.$tooltip.addClass('loading');

          scope.vm.tooltipContentFunc().then((data) => {
            scope.tooltipCached = true;
            scope.tooltip.innerHTML = $sanitize(data);
            scope.data = data;
            scope.$tooltip.removeClass('loading');
          });
        } else if (scope.isAsync) {
          scope.tooltip.innerHTML = scope.data;
        }

        if (render) {
          if (scope.isInline) {
            scope.wrap.append(scope.docfrag);
          } else {
            document.body.appendChild(scope.tooltip);
          }
        }
      }

      function getPosition(el) {
        let xPos = 0;
        let yPos = 0;

        while (el) {
          xPos += el.offsetLeft + el.clientLeft;
          yPos += el.offsetTop + el.clientTop;

          el = el.offsetParent;
        }

        return {
          left: xPos,
          top: yPos,
          bottom: document.body.offsetHeight - yPos,
        };
      }

      function removeTooltip() {
        scope.$tooltip.removeClass('open');
        scope.$tooltip.remove();
        if (transcludedContent) {
          transcludedContent.remove();
          transcludedContent = undefined;
        }
        if (transclusionScope) {
          transclusionScope.$destroy();
          transclusionScope = undefined;
        }
      }

      function handleMouseEnter() {
        buildTooltip();
      }

      function handleMouseLeave() {
        if(scope.vm.tooltipContent){
        if (scope.vm.tooltipContent.includes("href")){
          setTimeout(() => {
            removeTooltip();
          }, 2000);       
        }else{
          removeTooltip();
        }}
        else{
        removeTooltip();
        };
      }
    },
  };
};

lbTooltip.$inject = $inject;

export default lbTooltip;



// WEBPACK FOOTER //
// ./src/directives/lbTooltip/lbTooltipDirective.js